import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { post } from "../axios-post";
import { TMessageReaction, TSeachedUser } from "../../Types";

export const apiCallGetConversation = async ({
  senderId,
  recipientId,
  limit,
  offset,
  messageEra
}: {
  senderId: number;
  recipientId: number;
  limit: number;
  offset: number;
  messageEra: string;
}): Promise<{
  data: {
    conversation: {
      id: number;
      messageId: number;
      senderId: number;
      recipientId: number;
      message: string;
      sentOn: string;
      messageType: string;
      isDeleted: number;
      deletedOn: string;
      reactions: TMessageReaction[];
      hasReactionHistory: boolean;
    }[];
    senderUsername: string;
    recipientUsername: string;
    searchedUser: TSeachedUser;
  };
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<{
    conversation: {
      conversation: {
        id: number;
        messageId: number;
        senderId: number;
        recipientId: number;
        message: string;
        sentOn: string;
        messageType: string;
        isDeleted: number;
        deletedOn: string;
        reactions: TMessageReaction[];
        hasReactionHistory: boolean;
      }[];
      senderUsername: string;
      recipientUsername: string;
      searchedUser: TSeachedUser;
    };
  }>(`user/getUserConversation`, {
    senderId,
    recipientId,
    limit,
    offset,
    messageEra
  });

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: data.conversation,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: {
        conversation: [
          {
            id: -1,
            messageId: -1,
            senderId: -1,
            recipientId: -1,
            message: "",
            sentOn: "",
            messageType: "",
            isDeleted: 0,
            deletedOn: "",
            reactions: [],
            hasReactionHistory: false
          }
        ],
        senderUsername: "",
        recipientUsername: "",
        searchedUser: {
          userID: -1,
          userGender: ""
        }
      },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: {
        conversation: [
          {
            id: -1,
            messageId: -1,
            senderId: -1,
            recipientId: -1,
            message: "",
            sentOn: "",
            messageType: "",
            isDeleted: 0,
            deletedOn: "",
            reactions: [],
            hasReactionHistory: false
          }
        ],
        senderUsername: "",
        recipientUsername: "",
        searchedUser: {
          userID: -1,
          userGender: ""
        }
      },
      status: "ERROR",
      code: "ERROR"
    };
  }
};
